import React, { memo, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ptBR } from "date-fns/locale";
import "./AvaliacoesPorOrcamentar.scss";
import { localeText } from "../../../../../shared/util/datatableTranslations";
import { DataGrid } from "@mui/x-data-grid";

const PAGESIZE = 15;

function AvaliacoesPorOrcamentar({ open, data, handleCloseModal }) {
  const [shownData, setShownData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [dataInicio, setDataInicio] = useState(null);
  const [dataFim, setDataFim] = useState(null);

  useEffect(() => {
    setShownData(data);
  }, [data]);

  useEffect(() => {
    filterData();
  }, [searchTerm, dataInicio, dataFim, data]);

  const columns = [
    {
      field: "nome",
      headerName: "Cliente",
      flex: 5,
      renderCell: (params) => {
        return (
          <Link
            to={`/clientes/${params.row.idCliente}-avaliacao`}
            className="listaDivida__clientAnchor"
          >
            {params.row.nome}
          </Link>
        );
      },
    },
    {
      field: "contacto",
      headerName: "Contacto",
      flex: 2,
    },
    {
      field: "data",
      headerName: "Data",
      flex: 2,
    },
    {
      field: "medico",
      headerName: "Médico(a)",
      flex: 2,
    },
  ];

  const searchHandler = (e) => {
    setSearchTerm(e.target.value);
  };

  const filterData = () => {
    if (!data) return;

    let filteredData = data;

    // Filtro por nome
    if (searchTerm) {
      filteredData = filteredData.filter((dt) =>
        dt.nome.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // Filtro por data
    if (dataInicio || dataFim) {
      filteredData = filteredData.filter((dt) => {
        if (!dt.data) return false;

        // Parse da data no formato "11-04-2024 09:53"
        const [datePart] = dt.data.split(" "); // Pega só a parte da data
        const [day, month, year] = datePart.split("-");
        const dataAvaliacao = new Date(year, month - 1, day); // month - 1 porque Date usa mês base 0

        if (dataInicio && dataFim) {
          const inicio = new Date(dataInicio);
          const fim = new Date(dataFim);
          inicio.setHours(0, 0, 0, 0);
          fim.setHours(23, 59, 59, 999);
          return dataAvaliacao >= inicio && dataAvaliacao <= fim;
        } else if (dataInicio) {
          const inicio = new Date(dataInicio);
          inicio.setHours(0, 0, 0, 0);
          return dataAvaliacao >= inicio;
        } else if (dataFim) {
          const fim = new Date(dataFim);
          fim.setHours(23, 59, 59, 999);
          return dataAvaliacao <= fim;
        }

        return true;
      });
    }

    setShownData(filteredData);
  };

  const clearFilters = () => {
    setSearchTerm("");
    setDataInicio(null);
    setDataFim(null);
  };

  return (
    <Modal
      open={open}
      onClose={handleCloseModal.bind(null, "avaliacoes")}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        className="fluxo-atendimento__modal__box"
        id="orcamentos-por-aprovar__modal"
      >
        <div className="orcamentos-por-aprovar__modal__cabecalho">
          <h1 className="fluxo-atendimento__modal__titulo">
            Avaliações por orçamentar
          </h1>

          <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={ptBR}
          >
            <div className="orcamentos-por-aprovar__filtros">
              <div className="date-filters__container">
                <div className="date-filter">
                  <DatePicker
                    label="Data Início"
                    value={dataInicio}
                    onChange={(newValue) => setDataInicio(newValue)}
                    renderInput={(params) => (
                      <TextField {...params} size="small" variant="outlined" />
                    )}
                    inputFormat="dd/MM/yyyy"
                  />
                </div>

                <div className="date-filter">
                  <DatePicker
                    label="Data Fim"
                    value={dataFim}
                    onChange={(newValue) => setDataFim(newValue)}
                    renderInput={(params) => (
                      <TextField {...params} size="small" variant="outlined" />
                    )}
                    inputFormat="dd/MM/yyyy"
                  />
                </div>

                <div className="search__datatable__container">
                  <span>Procurar</span>
                  <input
                    type="search"
                    className="search__datatable__input"
                    placeholder="Procurar"
                    value={searchTerm}
                    onChange={searchHandler}
                  />
                </div>

                <button
                  className="clear-filters-btn"
                  onClick={clearFilters}
                  title="Limpar filtros"
                >
                  Limpar
                </button>
              </div>
            </div>
          </LocalizationProvider>
        </div>

        <div className="orcamentos-por-aprovar__modal__container">
          <DataGrid
            autoWidth
            className="datagrid"
            rows={shownData}
            columns={columns}
            pageSize={PAGESIZE}
            rowsPerPage={PAGESIZE}
            localeText={localeText}
          />
        </div>

        <div
          style={{
            gridColumn: "1/-1",
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "25px",
          }}
        >
          <span
            className="cancel-btn"
            onClick={handleCloseModal.bind(null, "avaliacoes")}
          >
            Fechar
          </span>
        </div>
      </Box>
    </Modal>
  );
}

export default memo(AvaliacoesPorOrcamentar);
